import React from 'react'
import Masonry from 'react-masonry-css'
import styled from 'styled-components'

import {
    RecipeItem,
    RecipeTitle,
    RecipePoints,
    RecipePrice,
    RecipeComposition,
    RecipeLabels,
    RecipeLabel,
    EnergyKCal,
} from '../../Kiosk/style'

import LabelIcons from '../../LabelIcons/LabelIcons'

const MasonryWrapper = styled(Masonry)`
    display: flex;
    flex-wrap: wrap;
    justify-content: center;

    padding: 20px 10%;

    zoom: ${props => props.zoom}; /* 1.8 */

    @media screen and (max-width: 1400px) {
        padding: 5px 5px;
    }

    /* position: absolute;
    top: 40%;
    width: 100%; */
    margin-top: 4%;
`

const RecipeWrapper = styled.div`
    position: relative;
    background-color: ${_ => _.theme.kiosk_background || '#eff1f1'};
    margin: 8px;
    padding: 1px 10px;
    border-radius: 3px;
    box-shadow: 0 1px 6px rgba(21, 24, 88, 0.05);
    transition: box-shadow 0.5s ease-in-out, -webkit-box-shadow 0.5s ease-in-out;
    /* border: 1px solid #d5d5d5; */
`

const monoKiosk = props => {
    const breakpointColumnsObj = {
        default: props.defaultColumnsCount || 2,
        1650: 2,
        1200: 1,
    }

    props.items.map(item => {
        if (!item.price) {
            return []
        }
        if (item.currency === 'CHF') {
            item.priceInt = `${item.currency} ${item.price.replace('.', ',')}`
            item.priceSup = ''
        } else {
            if (item.price_currency && !!item.price_currency) {
                const priceRegex = /(\d+)[,|.](\d+)(.*)/
                const priceMatches = priceRegex.exec(item.price_currency)

                item.priceInt = priceMatches[1]
                const decimals =
                    parseInt(priceMatches[2]) !== 0 ? priceMatches[2] : ''
                item.priceSup = priceMatches[3].trim() + decimals
            }
            if (item.price) {
                const priceArray = item.price.toString().split('.')
                item.priceInt =
                    priceArray[0].toString() + item.currency || props.currency
                item.priceSup = priceArray[1]
            }
        }
        return item
    })

    const content = props.items
        .filter(_ => _.menu_board_label)
        .map((item, index) => (
            <RecipeWrapper key={index}>
                <RecipeItem customStyle={item.produit_du_jour || ''}>
                    {item.produit_du_jour === 'produit_neo' && (
                        <img
                            src={`img/neo.jpg`}
                            style={{ height: '46px', marginTop: '-31px' }}
                        />
                    )}
                    <RecipeTitle>
                        <span style={{ marginRight: '.6em' }}>
                            {item.menu_board_label}
                        </span>
                        {!props.hideLabels && item.label && (
                            <RecipeLabel
                                src={`img/labels/${item.label}.png`}
                                onError={i => (i.target.style.display = 'none')}
                            />
                        )}
                        {!props.hideLabels && item.caracteristique_produit && (
                            <RecipeLabel
                                src={`img/labels/${item.caracteristique_produit}.png`}
                                onError={i => (i.target.style.display = 'none')}
                            />
                        )}
                    </RecipeTitle>

                    <>
                        {!props.hideRecipePoints && !!item.price_point ? (
                            <RecipePoints>
                                <span>{item.price_point}</span>
                            </RecipePoints>
                        ) : null}

                        {!props.hideMenuPrice &&
                        (!!item.price_currency || !!item.price) ? (
                            <RecipePrice>
                                <span>
                                    {item.priceInt}
                                    <span>{item.priceSup}</span>
                                </span>
                            </RecipePrice>
                        ) : null}
                    </>

                    {!props.hideComposition && !!item.composition ? (
                        <RecipeComposition>
                            {item.composition}
                        </RecipeComposition>
                    ) : null}

                    {!props.hideIntolerences && (
                        <RecipeLabels>
                            <LabelIcons
                                item={item}
                                size="24px"
                                dataSource={props.dataSource}
                            />
                        </RecipeLabels>
                    )}
                    {!props.hideEnergyKcal &&
                        (props.showEnergyKcalByPortion
                            ? !!item.energyKCalByPortion && (
                                  <EnergyKCal>
                                      <span>{item.energyKCalByPortion}</span>
                                  </EnergyKCal>
                              )
                            : !!item.energyKCal && (
                                  <EnergyKCal>
                                      <span>
                                          {item.energyKCal}
                                          <sup
                                              style={{
                                                  marginLeft: '0.2em',
                                                  fontSize: '0.6em',
                                              }}
                                          >
                                              100g
                                          </sup>
                                      </span>
                                  </EnergyKCal>
                              ))}
                </RecipeItem>
            </RecipeWrapper>
        ))

    return (
        <MasonryWrapper breakpointCols={breakpointColumnsObj} zoom={props.zoom}>
            {content}
        </MasonryWrapper>
    )
}

export default monoKiosk
